import Header from "../components/Header";
import TopSection from "../components/TopSection";
import Products from "../components/Products";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <TopSection />
      <Products />
      <Footer />
    </>
  );
};

export default Home;
